import { ConcretingType } from "@store/graphql/helpers/types.graphql";
import { useAtom, atom } from "@libraries/jotai";

const concretingsAtom = atom<ConcretingType[]>([]);
const filteredConcretingsAtom = atom<ConcretingType[]>([]);

export default function useConcretings() {
  const [value, setValue] = useAtom(concretingsAtom);
  const [filteredConcretings, setFilteredConcretings] = useAtom(
    filteredConcretingsAtom
  );

  return { value, setValue, filteredConcretings, setFilteredConcretings };
}
